import { useCallback, useState } from 'react';

import fetchUsers from '../services/usersService';

const EMPTY_PAGINATION = {
  page: 1,
  perPage: 0,
  totalItems: 0,
  totalPages: 0,
};

/**
 * Fetch state for the User Management users list.
 *
 * Mirrors components/pages/Users/hooks/useUsers, which backs the legacy user
 * access tables: the caller owns page/sort state and calls fetchUsersData in an
 * effect, so pagination and sorting stay server-side.
 */
const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState(EMPTY_PAGINATION);

  const fetchUsersData = useCallback(
    async ({
      access = null,
      filters = {},
      page = 1,
      query = '',
      sortBy = null,
      sortOrder = null,
    } = {}) => {
      try {
        setIsLoading(true);
        setError(null);

        const data = await fetchUsers({
          access,
          filters,
          page,
          query,
          sortBy,
          sortOrder,
        });

        setUsers(data.users);
        setPagination(data.pagination);
      } catch (err) {
        setError(err.message);
        setUsers([]);
        setPagination(EMPTY_PAGINATION);
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return { users, isLoading, error, pagination, fetchUsersData };
};

export default useUsers;
